/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Limits the amount of records to return. */
export type Limit = number;

/** Offsets the records to return. */
export type Offset = number;

/** ID of an object within the collection. */
export type ID = string;

/** Full URI string. */
export type URI = string;

/** Total number of records available within a collection query. */
export type Total = number;

/** A message that was sent in the chat. */
export type Message = string;

/** The owner of a message (USER or CHATBOT). */
export type Role = string;

/** N/A */
export type ToolCalls = string;

/** The initial guideline message set as a preamble for each question. */
export type Preamble = string;

/** The message to send as prompt in the chat request. */
export type Text = string;

/**
 * The RAG type to use.
 * Omit this parameter to add no RAG. Your prompt will be directly forwarded.
 * Possible values:
 *   - ANNOTATE => Add WWWW information
 *   - TEXT => Send text only
 * @default "ANNOTATE"
 */
export type RagType = string;

/**
 * The RAG mode to use.
 * Possible values:
 *   - FIRST => Search documents based only on the first message
 *   - LAST => Search documents based only on the last message
 *   - ALL => Search documents based on all messages
 * @default "FIRST"
 */
export type RagMode = string;

/**
 * How much of the summarized content to send as RAG.
 * @format int32
 * @default 25
 */
export type SummaryPct = number;

/** The ID to keep track of the conversation. If omitted, the conversation is not tracked. */
export type ConversationID = string;

/**
 * The response maximum amount of tokens.
 * @default 2500
 */
export type MaxTokens = number;

/**
 * Controls the randomness of the generated text.
 * Needs to be between 0-1.
 * ~0 = more deterministic and focused outputs.
 * ~1 = more creative and diverse outputs.
 * @default 0.5
 */
export type Temperature = number;

/**
 * Controls the repetition of tokens (words or phrases) in the generated text.
 * Needs to be between 0-1.
 * ~0 = Minimal or no penalty is applied.
 * ~1 = A strong penalty is applied to repeated words.
 * @default 0.5
 */
export type FrequencyPenalty = number;

/**
 * Controls the diversity of the generated text.
 * It does this by considering only the most probable next words, up to a certain cumulative probability, for sampling.
 * Needs to be between 0-1.
 * ~0 = Fewer words are considered, leading to more focused and deterministic outputs.
 * ~1 = More words are considered, leading to more diverse outputs.
 * @default 0.5
 */
export type TopP = number;

/**
 * Controls the diversity of the generated text by limiting the sampling pool to the top k most probable next words.
 * This parameter is used to control the trade-off between diversity and coherence in the generated text.
 * Needs to be greater or equal than 0.
 * ~10 = The model is restricted to the very top probable tokens, making the text more deterministic and focused.
 * ~100 = The model considers a larger set of tokens, introducing more variability and potential creativity.
 * @default 10
 */
export type TopK = number;

/**
 * Specifies which pre-trained language model you want to use for generating text.
 *
 * OCI Cohere options:
 * - cohere.command-r-08-2024
 * - cohere.command-r-plus-08-2024
 * - cohere.command-a-03-2025
 * @default "cohere.command-r-plus-08-2024"
 */
export type ModelID = string;

/**
 * The conversation language.
 *
 * This can be updated during the conversation. Switching language mid conversation without
 * updating this parameter is not recommended.
 *
 * If omitted:
 *   - For the first message of a conversation, the system will attempt to detect the language from this message.
 *   - For subsequent messages, the previously set language will be used.
 *
 * Supported languages:
 *   - `en` (English)
 *   - `nl` (Dutch)
 */
export type Language = string;

/**
 * The Dynizer API to use for RAG.
 * @format uri
 */
export type APIURL = string;

/** Sentence transformer model name */
export type TransformerModel = string;

/**
 * If true, the API will not prompt the LLM
 * @default false
 */
export type NoPrompt = boolean;

/**
 * If true, the API will not use a tool call
 * @default false
 */
export type NoToolCall = boolean;

/**
 * Parameters for selecting documents in RAG.
 *
 * Fields:
 * - `action`:
 *       The action to select documents from.
 * - `action_schema`:
 *       The action schema that the action belongs to.
 * - `action_label`:
 *       The action's actionlabel that contains the document.
 * - `action_label_id`:
 *       The action's actionlabel that contains a client id of a document.
 *       If omitted, defaults to the given `action_label`. These values are
 *       used to keep track of the documents in a session and are used as
 *       references in `citations` and `links` of a chat response.
 * - `action_label_name`:
 *       The action's actionlabel that contains a client name of a
 *       document. If omitted, defaults to the given `action_label`. These
 *       values are used in `links` of a chat response.
 * - `filter`:
 *       Filters the documents.
 * - `operation`:
 *       Specifies how elements in `filter` should be combined. Must be
 *       'AND' or 'OR'.
 * - `text_search`:
 *       Specifies whether to use text-based search to select relevant
 *       documents based on the user's message.
 *         - Documents deemed more relevant are more likely to be sent to
 *         the LLM and will have a higher score in the link response field.
 *         - If the `filter` parameter is empty, text_search is always
 *         applied.
 *         - If `text_search` is not applied, the order of selected
 *         documents will be random, and the likelihood of a document being
 *         sent to the LLM will also be random.
 * - `vector_search`:
 *       If true, vector search is used and all other parameters in this
 *       document_selector are ignored, as well as summary_pct and
 *       sentence_selector. This parameter cannot be changed within one
 *       conversation. If true, api_url and jwt bearer should match the
 *       internal dynizer url and authorization used by vector search.
 * - `max`:
 *       Applicable only if `text_search` is applied. Not for
 *       vector search. It specifies the maximum number of relevant
 *       documents returned from text_search. This also limits the number
 *       of documents sent to the LLM. If omitted, defaults to 10.
 * - `max_rag_tokens`:
 *       Maximum number of RAG tokens sent to the LLM.
 * - `top_rerank`:
 *       Number of top vector search results used in reranking. Applicable
 *       only for vector search.
 * - `priority`:
 *       Applicable only for vector search.
 */
export interface DocumentSelector {
  /** Dynizer action to use in a DocumentSelector */
  action: Action;
  /** Dynizer action schema to use in a DocumentSelector */
  action_schema?: ActionSchema;
  /** Dynizer actionlabel to use in a DocumentSelector or DocumentFilter. */
  action_label: ActionLabel;
  /** Dynizer actionlabel to use in a DocumentSelector or DocumentFilter. */
  action_label_id?: ActionLabel;
  /** Dynizer actionlabel to use in a DocumentSelector or DocumentFilter. */
  action_label_name?: ActionLabel;
  /** List of filter items to filter the RAG documents */
  filter?: DocumentFilter;
  /** Operation between filters, must be 'AND' or 'OR' */
  operation?: Operation;
  /** Indicates whether or not to use DQL's text_search() function in a DocumentSelector */
  text_search?: TextSearch;
  /** Indicates whether or not to use vector search function in a DocumentSelector */
  vector_search?: VectorSearch;
  /** Maximum number of RAG documents */
  max?: MaxDocuments;
  /** Maximum number of tokens sent to the LLM as RAG content. */
  max_rag_tokens?: MaxRagTokens;
  /** Number of top vector search results used in the reranker. */
  top_rerank?: TopRerank;
  /**
   * Priority definition.
   *
   * Field `categories` is an ordered list of category values. First value in
   * the category list has highest priority, last value has lowest priority.
   *
   * Field `action_label_priority` must match the internal actionlabel used for categorization.
   */
  priority?: Priority;
}

/**
 * Priority definition.
 *
 * Field `categories` is an ordered list of category values. First value in
 * the category list has highest priority, last value has lowest priority.
 *
 * Field `action_label_priority` must match the internal actionlabel used for categorization.
 */
export interface Priority {
  /** Dynizer actionlabel to use in a DocumentSelector or DocumentFilter. */
  action_label_priority?: ActionLabel;
  /** Array of string values to filter the RAG documents. */
  categories?: Values;
  /** Strategy for merging responses from different categories. */
  merge_strategy?: MergeStrategy;
}

/**
 * Parameters to select sentences from returned documents.
 *
 * Behaviour:
 *
 * - If this array is empty, returned documents will be summarized by the
 * system and sent to the LLM.
 * - If this array is non-empty, only the returned documents listed in this
 * array will be summarized and sent to the LLM. Returned documents not in
 * this array will not be sent to the LLM.
 *
 * Use this to create summaries by specifying sentence IDs instead of
 * relying on the system to generate summaries.
 */
export type SentenceSelector = SentenceSelectorItem[];

/**
 * Parameters to select sentences from a specific document.
 *
 * Behavior:
 * - If the `sentences` array is empty, the system will summarize the
 *   document.
 * - If specific `sentences` are listed, those sentences will form the
 *   document's summary.
 */
export interface SentenceSelectorItem {
  /** Client ID for a document */
  document_id?: ClientID;
  /** Sentence IDs to use from the document */
  sentences?: SentenceIDList;
}

/** Sentence IDs to use from the document */
export type SentenceIDList = SentenceID[];

/** Sentence ID to use from the document */
export type SentenceID = number;

/** Client ID for a document */
export type ClientID = string;

/** Unique reference ID that points to a dynizer document (an analysis) */
export type DynizerDocumentURI = string;

/** Client human-readable name for a document */
export type ClientName = string;

/** Text search score */
export type Score = number;

/**
 * Dynizer action schema to use in a DocumentSelector
 * @default "user"
 */
export type ActionSchema = string;

/** Dynizer action to use in a DocumentSelector */
export type Action = string;

/** Dynizer actionlabel to use in a DocumentSelector or DocumentFilter. */
export type ActionLabel = string;

/** Strategy for merging responses from different categories. */
export type MergeStrategy = string;

/** Array of string values to filter the RAG documents. */
export type Values = Value[];

/** Value to filter the RAG documents. */
export type Value = string;

/**
 * Name of a function that takes no arguments and returns one value, e.g. 'current_user'.
 * Used to filter the RAG documents.
 */
export type ValueFunction = string;

/**
 * Name of a function that takes no arguments and might return more than one row., e.g. 'current_microsoft_user_teams'.
 * Used to filter the RAG documents.
 */
export type SetReturningFunction = string;

/** Indicates whether or not to use DQL's text_search() function in a DocumentSelector */
export type TextSearch = boolean;

/**
 * Indicates whether or not to use vector search function in a DocumentSelector
 * @default true
 */
export type VectorSearch = boolean;

/**
 * Operation between filters, must be 'AND' or 'OR'
 * @default "OR"
 */
export type Operation = string;

/**
 * Maximum number of RAG documents
 * @default 10
 */
export type MaxDocuments = number;

/**
 * Number of top vector search results used in the reranker.
 * @default 83
 */
export type TopRerank = number;

/**
 * Maximum number of tokens sent to the LLM as RAG content.
 * @default 5333
 */
export type MaxRagTokens = number;

/** List of filter items to filter the RAG documents */
export type DocumentFilter = DocumentFilterItem[];

/**
 * A filter item.
 *
 * Use one of these property combinations:
 * - action_label  + value                   -> WHERE {action_label} = '{value}'
 * - action_label  + value_function          -> WHERE {action_label} = {value_function}()
 * - action_label  + set_returning_function  -> WHERE {action_label} IN (SELECT {set_returning_function}())
 * - filter        + operation (AND/OR)      -> WHERE ({filter1}) {operation} ({filter2}) {operation} ({filter3}) ...
 */
export interface DocumentFilterItem {
  /** Dynizer actionlabel to use in a DocumentSelector or DocumentFilter. */
  action_label?: ActionLabel;
  /** Value to filter the RAG documents. */
  value?: Value;
  /**
   * Name of a function that takes no arguments and returns one value, e.g. 'current_user'.
   * Used to filter the RAG documents.
   */
  value_function?: ValueFunction;
  /**
   * Name of a function that takes no arguments and might return more than one row., e.g. 'current_microsoft_user_teams'.
   * Used to filter the RAG documents.
   */
  set_returning_function?: SetReturningFunction;
  /** List of filter items to filter the RAG documents */
  filter?: DocumentFilter;
  /** Operation between filters, must be 'AND' or 'OR' */
  operation?: Operation;
}

/**
 * Chat properties.
 *
 * Behaviour:
 * - `document_selector`:
 *       Required for the first chat message of a conversation.
 *       For subsequent messages, the latest provided one will be used.
 * - `sentence_selector`
 *       Not required.
 *       If not provided or an empty array, the last provided sentence_selector for that conversation is used.
 *       It cannot be reset to null or an empty array.
 * - `history_override`:
 *       If provided, this will replace the chat history. An empty array will also replace the chat history.
 */
export interface Chat {
  /** The message to send as prompt in the chat request. */
  text: Text;
  /**
   * The RAG type to use.
   * Omit this parameter to add no RAG. Your prompt will be directly forwarded.
   * Possible values:
   *   - ANNOTATE => Add WWWW information
   *   - TEXT => Send text only
   */
  rag_type?: RagType;
  /**
   * The RAG mode to use.
   * Possible values:
   *   - FIRST => Search documents based only on the first message
   *   - LAST => Search documents based only on the last message
   *   - ALL => Search documents based on all messages
   */
  rag_mode?: RagMode;
  /** How much of the summarized content to send as RAG. */
  summary_pct?: SummaryPct;
  /** The ID to keep track of the conversation. If omitted, the conversation is not tracked. */
  conversation_id?: ConversationID;
  /** The response maximum amount of tokens. */
  max_tokens?: MaxTokens;
  /**
   * Controls the randomness of the generated text.
   * Needs to be between 0-1.
   * ~0 = more deterministic and focused outputs.
   * ~1 = more creative and diverse outputs.
   */
  temperature?: Temperature;
  /**
   * Controls the repetition of tokens (words or phrases) in the generated text.
   * Needs to be between 0-1.
   * ~0 = Minimal or no penalty is applied.
   * ~1 = A strong penalty is applied to repeated words.
   */
  frequency_penalty?: FrequencyPenalty;
  /**
   * Controls the diversity of the generated text.
   * It does this by considering only the most probable next words, up to a certain cumulative probability, for sampling.
   * Needs to be between 0-1.
   * ~0 = Fewer words are considered, leading to more focused and deterministic outputs.
   * ~1 = More words are considered, leading to more diverse outputs.
   */
  top_p?: TopP;
  /**
   * Controls the diversity of the generated text by limiting the sampling pool to the top k most probable next words.
   * This parameter is used to control the trade-off between diversity and coherence in the generated text.
   * Needs to be greater or equal than 0.
   * ~10 = The model is restricted to the very top probable tokens, making the text more deterministic and focused.
   * ~100 = The model considers a larger set of tokens, introducing more variability and potential creativity.
   */
  top_k?: TopK;
  /**
   * Specifies which pre-trained language model you want to use for generating text.
   *
   * OCI Cohere options:
   * - cohere.command-r-08-2024
   * - cohere.command-r-plus-08-2024
   * - cohere.command-a-03-2025
   */
  model_id?: ModelID;
  /**
   * The conversation language.
   *
   * This can be updated during the conversation. Switching language mid conversation without
   * updating this parameter is not recommended.
   *
   * If omitted:
   *   - For the first message of a conversation, the system will attempt to detect the language from this message.
   *   - For subsequent messages, the previously set language will be used.
   *
   * Supported languages:
   *   - `en` (English)
   *   - `nl` (Dutch)
   */
  language?: Language;
  /** The Dynizer API to use for RAG. */
  api_url: APIURL;
  /** If true, the API will not prompt the LLM */
  no_prompt?: NoPrompt;
  /** If true, the API will not use a tool call */
  no_tool_call?: NoToolCall;
  /**
   * Parameters for selecting documents in RAG.
   *
   * Fields:
   * - `action`:
   *       The action to select documents from.
   * - `action_schema`:
   *       The action schema that the action belongs to.
   * - `action_label`:
   *       The action's actionlabel that contains the document.
   * - `action_label_id`:
   *       The action's actionlabel that contains a client id of a document.
   *       If omitted, defaults to the given `action_label`. These values are
   *       used to keep track of the documents in a session and are used as
   *       references in `citations` and `links` of a chat response.
   * - `action_label_name`:
   *       The action's actionlabel that contains a client name of a
   *       document. If omitted, defaults to the given `action_label`. These
   *       values are used in `links` of a chat response.
   * - `filter`:
   *       Filters the documents.
   * - `operation`:
   *       Specifies how elements in `filter` should be combined. Must be
   *       'AND' or 'OR'.
   * - `text_search`:
   *       Specifies whether to use text-based search to select relevant
   *       documents based on the user's message.
   *         - Documents deemed more relevant are more likely to be sent to
   *         the LLM and will have a higher score in the link response field.
   *         - If the `filter` parameter is empty, text_search is always
   *         applied.
   *         - If `text_search` is not applied, the order of selected
   *         documents will be random, and the likelihood of a document being
   *         sent to the LLM will also be random.
   * - `vector_search`:
   *       If true, vector search is used and all other parameters in this
   *       document_selector are ignored, as well as summary_pct and
   *       sentence_selector. This parameter cannot be changed within one
   *       conversation. If true, api_url and jwt bearer should match the
   *       internal dynizer url and authorization used by vector search.
   * - `max`:
   *       Applicable only if `text_search` is applied. Not for
   *       vector search. It specifies the maximum number of relevant
   *       documents returned from text_search. This also limits the number
   *       of documents sent to the LLM. If omitted, defaults to 10.
   * - `max_rag_tokens`:
   *       Maximum number of RAG tokens sent to the LLM.
   * - `top_rerank`:
   *       Number of top vector search results used in reranking. Applicable
   *       only for vector search.
   * - `priority`:
   *       Applicable only for vector search.
   */
  document_selector?: DocumentSelector;
  /**
   * Parameters to select sentences from returned documents.
   *
   * Behaviour:
   *
   * - If this array is empty, returned documents will be summarized by the
   * system and sent to the LLM.
   * - If this array is non-empty, only the returned documents listed in this
   * array will be summarized and sent to the LLM. Returned documents not in
   * this array will not be sent to the LLM.
   *
   * Use this to create summaries by specifying sentence IDs instead of
   * relying on the system to generate summaries.
   */
  sentence_selector?: SentenceSelector;
  /** List of conversation items. */
  history_override?: ConversationList;
}

/** ConversationItem properties */
export interface ConversationItem {
  /** A message that was sent in the chat. */
  message?: Message;
  /** The owner of a message (USER or CHATBOT). */
  role?: Role;
  /** N/A */
  tool_calls?: ToolCalls;
}

/** List of conversation items. */
export type ConversationList = ConversationItem[] | null;

/** ConversationItem properties */
export interface Conversation {
  /** List of conversation items. */
  conversation?: ConversationList;
  /** The initial guideline message set as a preamble for each question. */
  preamble?: Preamble;
  /** List of Links. */
  links?: Links;
  /** List of citations in the current generated response. */
  citations?: Citations;
  /** List of documents cited in the current generated response. */
  citation_documents?: CitationDocuments;
}

/** List of citations in the current generated response. */
export type Citations = Citation[];

/** List of documents cited in the current generated response. */
export type CitationDocuments = CitationDocument[];

/** A citation in the model's response, linking a specific portion of the response text to input documents. */
export interface Citation {
  /** Client ids of cited documents */
  document_ids?: CitationClientIDs;
  /** The starting character position of the citation in the model's response text */
  start?: CitationStart;
  /** The ending character position of the citation in the model's response text */
  end?: CitationEnd;
  /** The exact segment of the model's response text that is cited from the input documents. */
  text?: CitationText;
}

/** A snippet from one of the input documents. */
export interface CitationDocument {
  /** Client ID for a document */
  id?: ClientID;
  /** Language detected for a document */
  language?: DocumentLanguage;
  /** A cited text snippet from an input document */
  snippet?: CitationDocumentSnippet;
}

/** Client ids of cited documents */
export type CitationClientIDs = ClientID[];

/** The starting character position of the citation in the model's response text */
export type CitationStart = number;

/** The ending character position of the citation in the model's response text */
export type CitationEnd = number;

/** The exact segment of the model's response text that is cited from the input documents. */
export type CitationText = string;

/** A cited text snippet from an input document */
export type CitationDocumentSnippet = string;

/** Language detected for a document */
export type DocumentLanguage = string;

/** List of Links. */
export type Links = Link[];

/**
 * Link to a dynizer document.
 *
 * `dynizer_document_uri`: dynizer URI of the document
 * `score`: relevancy score of the document
 * `client_id`: the value in the actionlabel `action_label_id` provided in the chat request
 * `client_name`: the value in the actionlabel `action_label_name` provided in the chat request
 * `used_fraction`: the fraction of the document summary sent to the LLM.
 */
export interface Link {
  /** Unique reference ID that points to a dynizer document (an analysis) */
  dynizer_document_uri?: DynizerDocumentURI;
  /** Text search score */
  score?: Score;
  /** Client ID for a document */
  client_id?: ClientID;
  /** Client human-readable name for a document */
  client_name?: ClientName;
  /** Number between 0 and 1 representing the fraction of the document summary sent to the LLM. */
  used_fraction?: UsedFraction;
}

/** Number between 0 and 1 representing the fraction of the document summary sent to the LLM. */
export type UsedFraction = number;

/** API error. */
export interface Error {
  /** @format int32 */
  code: number;
  message: string;
}

export interface CreateEmbedding {
  text?: string;
  model?: string;
  normalize?: boolean;
}

export interface CreateChunks {
  text?: string;
  model?: string;
  /** @default 0 */
  token_overlap?: number;
}

export interface CreateDocumentChunks {
  text?: string;
  model?: string;
  /** @default 0 */
  sentence_overlap?: number;
  clean?: boolean;
}

export interface TransformerInfo {
  name?: string;
  vector_size?: number;
  max_tokens?: number;
}

export interface Embedding {
  vector?: Vector;
}

export type Vector = VectorElement[];

export type VectorElement = number;

export interface GetChunks {
  chunks?: Chunks;
}

export interface GetDocumentChunks {
  chunks?: DocumentChunks;
}

export type Chunks = Chunk[];

export type DocumentChunks = DocumentChunk[];

export interface Chunk {
  character_start?: number;
  character_end?: number;
}

export interface DocumentChunk {
  sentence_id_start?: number;
  sentence_id_end?: number;
  text?: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Dynizer RAG API
 * @version 0.0.1
 * @contact Consono <info@consono.ai> (https://consono.ai)
 *
 * RAG based on Dynizer.
 * Unstable API.
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  cohere = {
    /**
     * @description Send a chat post request.
     *
     * @tags Chat
     * @name Chat
     * @request POST:/cohere/chat
     * @secure
     */
    chat: (data: Chat, params: RequestParams = {}) =>
      this.request<Conversation, Error>({
        path: `/cohere/chat`,
        method: "POST",
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Get a chat conversation by conversation ID.
     *
     * @tags Chat
     * @name GetChatById
     * @request GET:/cohere/chat/{id}
     * @secure
     */
    getChatById: (
      id: ID,
      query: {
        /** The Dynizer API to use for RAG. */
        api_url: APIURL;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConversationList, Error>({
        path: `/cohere/chat/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  transformer = {
    /**
     * @description Get transformer info
     *
     * @tags Transformer
     * @name GetTransformerInfo
     * @request GET:/transformer/info
     * @secure
     */
    getTransformerInfo: (
      query?: {
        /** The Dynizer API to use for RAG. */
        api_url?: APIURL;
        /** Sentence transformer model name */
        model?: TransformerModel;
      },
      params: RequestParams = {},
    ) =>
      this.request<TransformerInfo, Error>({
        path: `/transformer/info`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Send a transformer embed request.
     *
     * @tags Transformer
     * @name PostTransformerEmbed
     * @request POST:/transformer/embed
     * @secure
     */
    postTransformerEmbed: (
      data: CreateEmbedding,
      query?: {
        /** The Dynizer API to use for RAG. */
        api_url?: APIURL;
      },
      params: RequestParams = {},
    ) =>
      this.request<Embedding, Error>({
        path: `/transformer/embed`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Send a chunk text request.
     *
     * @tags Transformer
     * @name PostTransformerChunkText
     * @request POST:/transformer/chunk_text
     * @secure
     */
    postTransformerChunkText: (
      data: CreateChunks,
      query?: {
        /** The Dynizer API to use for RAG. */
        api_url?: APIURL;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetChunks, Error>({
        path: `/transformer/chunk_text`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description Send a chunk sentences request.
     *
     * @tags Transformer
     * @name PostTransformerChunkSentences
     * @request POST:/transformer/chunk_sentences
     * @secure
     */
    postTransformerChunkSentences: (
      data: CreateDocumentChunks,
      query?: {
        /** The Dynizer API to use for RAG. */
        api_url?: APIURL;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDocumentChunks, Error>({
        path: `/transformer/chunk_sentences`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        ...params,
      }),
  };
}
